import { BsStars, BsX } from 'react-icons/bs';

import FloatingActionButton from '#globalComponents/FloatingActionButton/FloatingActionButton';

import { useAgenticSearchStore } from '../../stores/agenticSearchStore';

/**
 * Floating Action Button to open/close the agentic search chat.
 * Positioned at the bottom-right corner of the page.
 */
const AgenticChatToggle = () => {
	const { isOpen, toggleOpen, phase } = useAgenticSearchStore();

	const isActive = phase !== 'idle';

	return (
		<div className="fixed bottom-6 right-28 z-40">
			<FloatingActionButton
				onClick={toggleOpen}
				tone={isOpen ? 'neutral' : 'primary'}
				pressed={isOpen}
				className="relative"
				title="KI-Suche"
			>
				{isOpen ? (
					<BsX className="w-6 h-6" />
				) : (
					<>
						<BsStars className="w-6 h-6" />
						{isActive && (
							<span className="absolute top-1 right-1 w-3 h-3 bg-green-400 rounded-full border-2 border-white" />
						)}
					</>
				)}
			</FloatingActionButton>
		</div>
	);
};

export default AgenticChatToggle;
